export default {
  version: 'master',
  compilation: '218407'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1472
// module chunks = 22